import { IdentityTypeNameDecorator, Expose, BaseIdentity } from '@nts/std';
import { SignTemplateParamsIdentity } from '../../domain-models/sign-template-params.identity';

@IdentityTypeNameDecorator('SignerSettingsIdentity')
export class GeneratedSignerSettingsIdentity extends SignTemplateParamsIdentity {

	private _signerSerial: number;

	@Expose()
	public get signerSerial(): number {
		return this.getValue<number>(() => this._signerSerial, 'signerSerial');
	}
	public set signerSerial(value: number) {
		this.setValue<number>(() => { this._signerSerial = value; }, value, 'signerSerial');
	}
}
